<template>
  <div class="navigator-top-container">
    <div class="nav-space" />
    <div class="navigator-container">
      <div class="nav-icons">
        <i class="icon-logo" />
        <!-- <i class="icon-ticket"></i> -->
      </div>
      <div class="nav-buttons">
        <div
          v-for="item in navLists.filter(i => i.value !== 'Share')"
          :key="item.value"
          class="nav-item"
          @click="scrollTo(item.value)"
          v-rseat="`click_carnival_nav_${item.value}`"
        >
          {{ item.label }}
        </div>
      </div>
    </div>
    <div class="nav-space-last"></div>
  </div>
</template>
<script>
import { NAV_ITEMS } from './constants'

const DELTA = 112

export default {
  props: {
    navLists: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      navList: NAV_ITEMS,
    }
  },
  methods: {
    scrollTo(active) {
      const navContent = document.querySelectorAll(`[data-anchor="${active}"]`)[0]
      const cityTab = document.querySelector('[data-city-tab]')
      const cityTabHeight = cityTab ? cityTab.offsetHeight : DELTA
      // window 宽度小于 1366 页面缩放75%
      const windowWidth = window.innerWidth
      const scrollHei = navContent.offsetTop - cityTabHeight
      const top = windowWidth > 1366 ? scrollHei : scrollHei * 0.75
      if (navContent) {
        window.scrollTo({
          top,
          behavior: 'smooth',
        })
      }
    },
  },
}
</script>
<style lang="less" scoped>
.navigator-top-container {
  position: absolute;
  top: 0;
  background-color: transparent;
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
  height: 89px;
  display: flex;
  .nav-space {
    flex: 1;
    background-color: #000;
  }
  .nav-space-last {
    flex-grow: 2;
    background-color: #000;
    margin-left: -1px;
  }
  .navigator-container {
    flex: none;
    display: flex;
  }
  .nav-icons {
    display: flex;
    height: 89px;
    align-items: center;
    background-color: #000;
    margin-right: -1px;
  }
  .icon-logo {
    display: block;
    width: 193px;
    height: 51px;
    background: transparent url('~@/assets/carnival2020/main-kv/icon-logo.png') center center no-repeat;
    background-size: contain;
    margin-right: 65px;
  }
  .icon-ticket {
    display: block;
    width: 161px;
    height: 89px;
    background: transparent url('~@/assets/carnival2020/main-kv/nav-ticket.png') center center no-repeat;
    background-size: contain;
    cursor: pointer;
  }
  .nav-buttons {
    display: flex;
    align-items: center;
    background: linear-gradient(
      to right,
      #000 0%,
      #000 10%,
      rgba(0, 0, 0, 0.77) 10%,
      rgba(0, 0, 0, 0.77) 90%,
      #000 90%,
      #000 100%
    );
  }
  .nav-item {
    width: 182px;
    height: 89px;
    font-size: 18px;
    line-height: 89px;
    color: #9972ff;
    letter-spacing: 7px;
    background: transparent url('~@/assets/carnival2020/main-kv/nav-item-bg.png') center center no-repeat;
    background-size: cover;
    text-align: center;
    margin: 0 -17px;
    cursor: pointer;
  }
}
</style>
